import React, {useState} from 'react';
import {Image, View} from 'react-native';
import CCText from '@/Atoms/CCText';

interface Props {
  initials: string;
  color: string;
  size?: number;
  ring?: string;
  avatarUrl?: string;
}

/** Circular avatar: profile image when available, initials circle otherwise. */
export default function PlayerAvatar({
  initials,
  color,
  size = 40,
  ring,
  avatarUrl,
}: Props) {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = !!avatarUrl && !imageFailed;

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: color,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: ring ? 3 : 0,
        borderColor: ring || 'transparent',
        overflow: 'hidden',
      }}>
      {showImage ? (
        <Image
          source={{uri: avatarUrl}}
          style={{width: size, height: size, borderRadius: size / 2}}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <CCText
          fontSize={Math.round(size * 0.32)}
          fontWeight="bold"
          color="#FFFFFF">
          {initials}
        </CCText>
      )}
    </View>
  );
}
